import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import LocalCache from 'src/common/LocalCache';
import { environment } from 'src/environments/environment';

const thirdPartyTag = 'thirdParty';

/** RTK Query API slice for third-party service endpoints. */
export const thirdPartyApi = createApi({
  reducerPath: 'thirdPartyApi',
  // reducerPath: thirdPartyTag + 'Api',
  tagTypes: [thirdPartyTag],
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    /** Query to fetch IP-based location using ipinfo.io. */
    getIPLocation: builder.query<{ lat: number; lng: number; country: string } | undefined, void>({
      query: () => ({ url: `https://ipinfo.io?token=${environment.VITE_IPINFO_TOKEN}` }),
      transformResponse(data: any) {
        if (data?.loc) {
          const coords = {
            lat: Number(data?.loc?.split(',')[0]) || 0,
            lng: Number(data?.loc?.split(',')[1]) || 0,
          };
          LocalCache.saveIPLocation({ country: data.country?.toLocaleLowerCase() || 'pk', ...coords });
          return { country: data.country?.toLocaleLowerCase() || 'pk', ...coords };
        }
      },
    }),
  }),
});

/** RTK Query hook for fetching IP-based location. */
export const { useLazyGetIPLocationQuery } = thirdPartyApi;
